import { useState } from 'react';
import { formatDate } from '../../../../../components/Booking-new/utils/helpers/bookingMomentHelpers';

export const useFilterDates = showDailyFilters => {
  if (!showDailyFilters) return null;

  const today = new Date();
  const next14Days = [];

  let date = new Date(today);
  while (next14Days.length < 14) {
    const day = date.getDay();
    if (day !== 0 && day !== 6)
      // 0 = Sunday, 6 = Saturday
      next14Days.push({
        apiFormat: date.toISOString().split('T')[0],
        formatted: formatDate(new Date(date)),
        og: new Date(date),
      });
    date.setDate(date.getDate() + 1);
  }
  const shortenWeekday = dateStr => {
    // match the first two letters of the weekday
    const weekdayMatch = dateStr.match(/^(\w{2})\w+,\s/);
    if (weekdayMatch) return dateStr.replace(/^(\w{2})\w+,\s/, `${weekdayMatch[1]}, `);

    return dateStr;
  };

  // apply the shortening of weekdays
  const shortenedWeekdays = next14Days.map(date => ({
    apiFormat: date.apiFormat,
    formatted: shortenWeekday(date.formatted),
    og: date.og,
  }));

  const [selectedDates, setSelectedDates] = useState([]);
  const [resetDates, setResetDates] = useState(true);
  // put selected dates first
  const getSortedDates = () => {
    const sortedDates = [...shortenedWeekdays];
    sortedDates.sort((a, b) => {
      const aSelected = selectedDates.some(d => d.formatted === a.formatted);
      const bSelected = selectedDates.some(d => d.formatted === b.formatted);

      if (aSelected && !bSelected) return -1;
      if (!aSelected && bSelected) return 1;
      return 0;
    });

    return sortedDates;
  };

  const sortedDates = getSortedDates();

  return {
    sortedDates,
    selectedDates,
    setSelectedDates,
    resetDates,
    setResetDates,
  };
};
